import { CancelToken } from 'axios';
import BuildingDirectoryApi from '../api/routes/BuildingDirectoryApi';
import { SearchTransactionDataModel } from '../pages/TransactionData/models/search-transaction-data.model';
import { TransactionDataInfo } from '../pages/TransactionData/models/transaction-data-info.model';

const dummyTransactionData: TransactionDataInfo[] = [
    new TransactionDataInfo({
        id: 'txn-dummy-1',
        propertyName: 'Asia Logistics Hub',
        address: '1 Jurong Port Road',
        postcode: 619100,
        country: 'Singapore',
        city: 'Singapore',
        state: 'SG',
        mainSector: 'Industrial',
        tenancy: 'Multi-tenant',
        yearBuilt: 2017,
        numberBuildings: 4,
        numberFloors: '6',
        transactionType: 'Sale',
        transactionSubType: 'Asset',
        buyerObjective: 'Investment',
        portfolio: 'No',
        status: 'Closed',
        saleDate: '2024-05-20T00:00:00.000Z',
        saleValue: 420000000,
        assetValue: 430000000,
        sqFt: 760000,
        lat: 1.3102,
        lon: 103.7069,
        buyerCapInvComp: 'Institutional',
    }),
    new TransactionDataInfo({
        id: 'txn-dummy-2',
        propertyName: 'Sydney CBD Office One',
        address: '88 Pitt St',
        postcode: 2000,
        country: 'Australia',
        city: 'Sydney',
        state: 'NSW',
        mainSector: 'Office',
        tenancy: 'Single',
        yearBuilt: 2012,
        numberBuildings: 1,
        numberFloors: '32',
        transactionType: 'Sale',
        transactionSubType: 'Portfolio',
        buyerObjective: 'Occupancy',
        portfolio: 'Yes',
        status: 'Closed',
        saleDate: '2023-11-13T00:00:00.000Z',
        saleValue: 615000000,
        assetValue: 620000000,
        sqFt: 980000,
        lat: -33.8688,
        lon: 151.2093,
        buyerCapInvComp: 'Public',
    }),
    new TransactionDataInfo({
        id: 'txn-dummy-3',
        propertyName: 'Tokyo Midtown Retail',
        address: '2-2-1 Yaesu',
        postcode: 1040028,
        country: 'Japan',
        city: 'Tokyo',
        state: 'Tokyo',
        mainSector: 'Retail',
        tenancy: 'Multi-tenant',
        yearBuilt: 2019,
        numberBuildings: 1,
        numberFloors: '14',
        transactionType: 'Sale',
        transactionSubType: 'Asset',
        buyerObjective: 'Renovation',
        portfolio: 'No',
        status: 'Closed',
        saleDate: '2022-08-01T00:00:00.000Z',
        saleValue: 355000000,
        assetValue: 360000000,
        sqFt: 420000,
        lat: 35.6812,
        lon: 139.7671,
        buyerCapInvComp: 'Private',
    }),
    new TransactionDataInfo({
        id: 'txn-dummy-4',
        propertyName: 'Bangkok Riverside Hotel',
        address: '120 Charoen Krung Rd',
        postcode: 10500,
        country: 'Thailand',
        city: 'Bangkok',
        state: 'Bangkok',
        mainSector: 'Hotel',
        tenancy: 'Owner operated',
        yearBuilt: 2015,
        numberBuildings: 1,
        numberFloors: '18',
        transactionType: 'Sale',
        transactionSubType: 'Asset',
        buyerObjective: 'Redevelopment',
        portfolio: 'No',
        status: 'Closed',
        saleDate: '2021-02-18T00:00:00.000Z',
        saleValue: 210000000,
        assetValue: 220000000,
        sqFt: 300000,
        lat: 13.7563,
        lon: 100.5018,
        buyerCapInvComp: 'User/Other',
    }),
];

const applyDummyFilters = (
    list: TransactionDataInfo[],
    filterParams?: SearchTransactionDataModel
): TransactionDataInfo[] => {
    if (!filterParams) {
        return list;
    }

    return list.filter((item) => {
        if (filterParams.sectors?.length && !filterParams.sectors.includes(item.mainSector)) {
            return false;
        }
        if (filterParams.country && item.country !== filterParams.country) {
            return false;
        }
        if (filterParams.city && item.city !== filterParams.city) {
            return false;
        }
        if (filterParams.buyerObjective && item.buyerObjective !== filterParams.buyerObjective) {
            return false;
        }
        if (filterParams.buyerCapInvComp && item.buyerCapInvComp !== filterParams.buyerCapInvComp) {
            return false;
        }
        if (filterParams.startYearBuilt && item.yearBuilt && item.yearBuilt < filterParams.startYearBuilt) {
            return false;
        }
        if (filterParams.endYearBuilt && item.yearBuilt && item.yearBuilt > filterParams.endYearBuilt) {
            return false;
        }
        if (filterParams.priceMin && item.saleValue && item.saleValue < filterParams.priceMin) {
            return false;
        }
        if (filterParams.priceMax && item.saleValue && item.saleValue > filterParams.priceMax) {
            return false;
        }
        if (filterParams.dateFrom && item.saleDate) {
            if (new Date(item.saleDate).getTime() < new Date(filterParams.dateFrom).getTime()) {
                return false;
            }
        }
        if (filterParams.dateTo && item.saleDate) {
            if (new Date(item.saleDate).getTime() > new Date(filterParams.dateTo).getTime()) {
                return false;
            }
        }
        return true;
    });
};

const fecthAllTransactionData = async (cancelToken: CancelToken, filterParams?: SearchTransactionDataModel) => {
    try {
        const { data } = await BuildingDirectoryApi.fetchAllTransactionData(cancelToken, filterParams);
        if (data?.length) {
            return data;
        }
        return applyDummyFilters(dummyTransactionData, filterParams);
    } catch (e) {
        return applyDummyFilters(dummyTransactionData, filterParams);
    }
}

const fetchTransactionDataById = async (id: string) => {
    try {
        const localItem = dummyTransactionData.find((x) => x.id === id);
        if (localItem) {
            return localItem;
        }
        const { data } = await BuildingDirectoryApi.fetchTransactionDataById(id);
        return data;
    } catch (e) {
        const localItem = dummyTransactionData.find((x) => x.id === id);
        if (localItem) {
            return localItem;
        }
        throw e;
    }
}

const TransactionDataService = {
    fecthAllTransactionData,
    fetchTransactionDataById
}

export default TransactionDataService;